import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './Button';
export const HeroSection = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-8 pb-10 px-4 md:px-8 bg-brand-cream overflow-hidden" data-id="element-83">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-85">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-green leading-tight" data-id="element-86">
            Cómo Desinflamar tu Vientre, Eliminar la Neblina Mental y Dormir 8
            Horas Del Tirón en 30 Días Sin Contar Calorías ni Matarte en el
            Gimnasio
          </h1>

          <p className="text-lg md:text-xl text-brand-charcoal/80 italic" data-id="element-87">
            — Incluso si sientes que tus hormonas te han traicionado y nada de
            lo que antes funcionaba te da resultados ahora.
          </p>

          <p className="text-base md:text-lg text-brand-charcoal leading-relaxed border-l-4 border-brand-gold pl-4" data-id="element-88">
            Deja de luchar contra tu bioquímica. Aprende el método de
            Resiliencia Metabólica diseñado exclusivamente para mujeres en
            premenopausia y menopausia que están hartas de las dietas genéricas.
          </p>

          <div className="pt-4" data-id="element-89">
            <CTAButton onClick={scrollToPricing} data-id="element-90">
              SÍ, QUIERO MI PAZ HORMONAL — ACCESO POR $37
            </CTAButton>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-91">
          <div className="absolute inset-0 bg-brand-gold/10 rounded-full blur-3xl transform scale-90" data-id="element-92"></div>
          <img src="https://cdn.magicpatterns.com/uploads/3To3fFMjn2GzTqG8jFE8Ff/Imagen_Producto.png" alt="El Código Hormonal +40" className="relative z-10 w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-93" />
        </motion.div>
      </div>
    </section>;
};